import { render, staticRenderFns } from "./AzDataDeNascimento.vue?vue&type=template&id=fc575d82&"
import script from "./AzDataDeNascimento.vue?vue&type=script&lang=js&"
export * from "./AzDataDeNascimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports